export default __webpack_public_path__ + "static/media/Q08_安穩吃草圓滾滾的野兔.823f8735.mp4";